export function PlayerStats() {
  return (
    <div className="space-y-10">

      {/* PAGE HEADER */}
      <div>
        <h1 className="text-3xl font-bold mb-2">Player Stats</h1>
        <p className="text-muted">
          Internal intelligence for analyzing individual player performance, trends, and map strengths.
        </p>
      </div>

      {/* PLAYER SELECTOR */}
      <section className="bg-surface border border-border rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-4">Select Player</h2>

        <select
          className="
            w-full bg-bg border border-border rounded-md p-3
            focus:outline-none focus:border-[#4FC3F7]
          "
        >
          <option>Select a player...</option>
          <option>Player 1</option>
          <option>Player 2</option>
          <option>Player 3</option>
        </select>
      </section>

      {/* PLAYER SUMMARY */}
      <section className="bg-surface border border-border rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-6">Player Overview</h2>

        <div className="flex flex-col md:flex-row items-center gap-6">

          {/* Avatar */}
          <div className="w-24 h-24 rounded-full bg-[#1F242C]" />

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 w-full">

            <div className="bg-bg border border-border rounded-md p-4">
              <p className="text-muted text-sm">ELO</p>
              <p className="font-semibold text-[#4FC3F7] text-lg">2450</p>
            </div>

            <div className="bg-bg border border-border rounded-md p-4">
              <p className="text-muted text-sm">Role</p>
              <p className="font-semibold">Rifler</p>
            </div>

            <div className="bg-bg border border-border rounded-md p-4">
              <p className="text-muted text-sm">Maps Played</p>
              <p className="font-semibold">132</p>
            </div>

            <div className="bg-bg border border-border rounded-md p-4">
              <p className="text-muted text-sm">Win Rate</p>
              <p className="font-semibold">58%</p>
            </div>

          </div>
        </div>
      </section>

      {/* GRAPH GRID */}
      <div className="grid lg:grid-cols-2 gap-8">

        {/* ELO TREND */}
        <section className="bg-surface border border-border rounded-lg p-6 flex flex-col">
          <h2 className="text-xl font-semibold mb-4">ELO Over Time</h2>

          <div
            className="
              flex-grow bg-bg border border-border rounded-md
              h-64 flex items-center justify-center text-muted
            "
          >
            Graph Placeholder
          </div>
        </section>

        {/* MAP PERFORMANCE */}
        <section className="bg-surface border border-border rounded-lg p-6 flex flex-col">
          <h2 className="text-xl font-semibold mb-4">Performance by Map</h2>

          <div
            className="
              flex-grow bg-bg border border-border rounded-md
              h-64 flex items-center justify-center text-muted
            "
          >
            Graph Placeholder
          </div>
        </section>

        {/* RECENT MATCH TREND */}
        <section className="bg-surface border border-border rounded-lg p-6 flex flex-col lg:col-span-2">
          <h2 className="text-xl font-semibold mb-4">Recent Match Rating Trend</h2>

          <div
            className="
              flex-grow bg-bg border border-border rounded-md
              h-72 flex items-center justify-center text-muted
            "
          >
            Graph Placeholder
          </div>
        </section>

      </div>

      {/* DETAILED STATS GRID */}
      <section className="bg-surface border border-border rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-6">Detailed Stats</h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">

          <div className="bg-bg border border-border rounded-md p-4">
            <p className="text-muted text-sm">Average K/D</p>
            <p className="font-semibold">1.12</p>
          </div>

          <div className="bg-bg border border-border rounded-md p-4">
            <p className="text-muted text-sm">Headshot %</p>
            <p className="font-semibold">47%</p>
          </div>

          <div className="bg-bg border border-border rounded-md p-4">
            <p className="text-muted text-sm">Entry Success</p>
            <p className="font-semibold">54%</p>
          </div>

          <div className="bg-bg border border-border rounded-md p-4">
            <p className="text-muted text-sm">Clutch Win %</p>
            <p className="font-semibold">18%</p>
          </div>

        </div>
      </section>

    </div>
  );
}